import React from "react";
import SingleOrderDetail from "./SingleOrderDetail";
import DeviderBorder from "../utils/DeviderBorder";
import useCart from "../../hooks/useCart";
import useCoupon from "../../hooks/useCoupon";

const OrderSummaryContainer = () => {
  const { cartData } = useCart();
  const { couponData } = useCoupon();

  const subTotal = cartData?.items?.reduce((acc, item) => {
    const isUpsell = item.properties?.upsell_discount === "true";

    if (isUpsell) {
      // upsell item → use regular price for subtotal
      return acc + (item.price || 0) * item.quantity;
    }

    const price = item.compare_at_price || item.price || 0;
    return acc + price * item.quantity;
  }, 0);

  const regularTotal = cartData?.items?.reduce((acc, item) => {
    const isUpsell = item.properties?.upsell_discount === "true";
    const upsellPrice = item.properties?.upsell_price;

    if (isUpsell && upsellPrice) {
      // upsell item → use upsell_price (in rupees, convert to paise)
      return acc + upsellPrice * item.quantity * 100;
    }

    return acc + (item.price || 0) * item.quantity;
  }, 0);

  const formattedSubTotal = (subTotal / 100).toFixed(0);
  const formattedRegularTotal = (regularTotal / 100).toFixed(0);

  return (
    <div className="p-4">
      <div className="bg-[#FFFFFF80] p-4 rounded-lg shadow-sm border-[#00000010] border">
        {cartData?.items?.map((data, index) => {
          return (
            <SingleOrderDetail
              mt={index !== 0 ? "mt-2" : ""}
              data={data}
              key={data.id}
            />
          );
        })}

        <div className="mt-4">
          <p className="text-[18px] supreme-bold">Bill summary</p>
          <div className="flex items-center justify-between mt-4">
            <p className="text-[13px] general-sans-medium">Sub total</p>
            <p className="text-[13px] general-sans-medium">
              ₹{formattedSubTotal}
            </p>
          </div>

          {formattedSubTotal - formattedRegularTotal > 0 ? (
            <div className="flex items-center justify-between mt-3">
              <p className="text-[13px] general-sans-medium text-green-600 opacity-90">
                Discount on MRP
              </p>
              <p className="text-[13px] general-sans-medium text-green-600 opacity-90">
                - ₹{formattedSubTotal - formattedRegularTotal}
              </p>
            </div>
          ) : (
            <></>
          )}

          {couponData?.applied && couponData?.appliedCoupon?.discountAmount && (
            <div className="flex items-center justify-between mt-3">
              <p className="text-[13px] general-sans-medium text-green-600 opacity-90">
                Auto discount ({couponData?.appliedCoupon?.coupon_name})
              </p>
              <p className="text-[13px] general-sans-medium text-green-600 opacity-90">
                - ₹{(couponData?.appliedCoupon?.discountAmount).toFixed(0)}
              </p>
            </div>
          )}

          <div className="mt-3">
            <DeviderBorder />
          </div>
          <div className="flex items-center justify-between mt-3">
            <p className="text-[15px] supreme-bold">Total amount</p>
            <p className="text-[15px] supreme-bold">
              ₹
              {couponData?.appliedCoupon?.discountAmount
                ? (
                    formattedRegularTotal -
                    couponData?.appliedCoupon?.discountAmount
                  ).toFixed(0)
                : formattedRegularTotal}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryContainer;
